import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  (theme) => ({
    sendEmailContainer: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
    },
    sendEmailBtn: {
      borderColor: theme.palette.grey[200],
      width: "fit-content", 
      display: "flex", 
      alignItems:"center", 
      fontSize: "14px", 
      justifyContent: "center", 
      cursor: "pointer",
      lineHeight: "20px",
    },
  }),
  { index: 1 }
);
